import { requestGet } from '@/common/request';

export interface tagsRes {
  ret: string;
  msg: string;
  data: {
    marketSceneTags: Array<{ code: string; name: string }> | [];
    activityTypeTags: Array<{ code: string; name: string }> | [];
  };
}

//
export async function tags(): Promise<tagsRes> {
  return await requestGet('/generic/mac/square/tags');
}
